import PanelExample from "./examples/Panel.Example";
import CustomPanelExample from "./examples/CustomPanel.Example";

export default [
    {
        title: "Basic panel",
        component: PanelExample,
        code: require("!raw-loader!./examples/Panel.Example.tsx")
    },
    {
        title: "Custom panel",
        component: CustomPanelExample,
        code: require("!raw-loader!./examples/CustomPanel.Example.tsx")
    }
];
